/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConfirmRequestInternallyDTO,
  ErrorResponse,
  ExpiringSoonRequestDTO,
  ExtendRequestDatesDTO,
  MailHistoryDTO,
  Pageable,
  RecipientCandidateSort,
  RequestDTO,
  RequestRecipientCandidatePageDTO,
  RequestSearchParamsDTO,
  RequestSearchResultDTO,
  RequestValidationParamsDTO,
  UpdateAdditionalInformationDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RequestApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags request-api
   * @name CancelPreviouslyPublishedRequest
   * @summary Cancel a previously published request with a current status of 'CREATED'
   * @request POST:/api/requests/{id}/cancel-previously-published
   * @secure
   */
  cancelPreviouslyPublishedRequest = (
    id: number,
    query: {
      cancellationReason: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/cancel-previously-published`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name CancelRequest
   * @summary Cancel an request by ID
   * @request POST:/api/requests/{id}/cancel
   * @secure
   */
  cancelRequest = (
    id: number,
    query: {
      cancellationReason: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/cancel`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name ConfirmRequestInternally
   * @summary Confirm a deactivated request internally (operator only) with a mandatory reason
   * @request POST:/api/requests/{id}/confirm-internally
   * @secure
   */
  confirmRequestInternally = (
    id: number,
    data: ConfirmRequestInternallyDTO,
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/confirm-internally`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name CreateAndPublishRequest
   * @summary Create and publish a new request
   * @request PUT:/api/requests/create-and-publish
   * @secure
   */
  createAndPublishRequest = (data: RequestDTO, params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse>({
      path: `/api/requests/create-and-publish`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name CreateRequest
   * @summary Create a new request
   * @request PUT:/api/requests
   * @secure
   */
  createRequest = (data: RequestDTO, params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse>({
      path: `/api/requests`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name DeleteRequest
   * @summary Delete a request
   * @request DELETE:/api/requests/{id}
   * @secure
   */
  deleteRequest = (id: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/requests/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name ExtendRequestDates
   * @summary Extend dates of a published or to-be-confirmed request
   * @request POST:/api/requests/{id}/extend-dates
   * @secure
   */
  extendRequestDates = (
    id: number,
    data: ExtendRequestDatesDTO,
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/extend-dates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name GetExpiringSoon
   * @summary List own requests expiring within the configurable validity-reminder window for the current company
   * @request GET:/api/requests/expiring-soon
   * @secure
   */
  getExpiringSoon = (params: RequestParams = {}) =>
    this.request<ExpiringSoonRequestDTO[], ErrorResponse>({
      path: `/api/requests/expiring-soon`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name GetRecipientCandidates
   * @summary Get the recipient candidates for the 'set recipients' selection dialog: the requester's active, whitelisted companies with distance to a delivery address
   * @request GET:/api/requests/recipient-candidates
   * @secure
   */
  getRecipientCandidates = (
    query: {
      /** @format int64 */
      deliveryAddressId?: number;
      name?: string;
      pageable: Pageable;
      /** @default "NAME_ASC" */
      sortBy?: RecipientCandidateSort;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestRecipientCandidatePageDTO, ErrorResponse>({
      path: `/api/requests/recipient-candidates`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name GetRequest
   * @summary Get an request by ID
   * @request GET:/api/requests/{id}
   * @secure
   */
  getRequest = (id: number, params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name GetRequestCloned
   * @summary Get cloned request template by ID
   * @request GET:/api/requests/{id}/clone
   * @secure
   */
  getRequestCloned = (id: number, params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/clone`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name GetRequestEMailHistory
   * @summary Get all details of an request by ID
   * @request GET:/api/requests/{id}/email-history
   * @secure
   */
  getRequestEMailHistory = (id: number, params: RequestParams = {}) =>
    this.request<MailHistoryDTO, ErrorResponse | MailHistoryDTO>({
      path: `/api/requests/${id}/email-history`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name GetRequestTemplate
   * @summary Get a template for creating a new request
   * @request GET:/api/requests/template
   * @secure
   */
  getRequestTemplate = (params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse>({
      path: `/api/requests/template`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Carries no body and therefore always publishes to all eligible companies (recipient mode 'ALL'). To restrict the recipient scope, use create-and-publish or update-and-publish instead, which carry the recipient selection in the request body.
   *
   * @tags request-api
   * @name PublishRequest
   * @summary Publish an request by ID
   * @request POST:/api/requests/{id}/publish
   * @secure
   */
  publishRequest = (id: number, params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/publish`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name ResendPublishNotification
   * @summary Manually re-send the EM-15 publish-notification mail to eligible suppliers (operator only)
   * @request POST:/api/requests/{id}/resend-publish-notification
   * @secure
   */
  resendPublishNotification = (id: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/requests/${id}/resend-publish-notification`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name SearchRequests
   * @summary Get one page of requests for overview purposes
   * @request POST:/api/requests
   * @secure
   */
  searchRequests = (data: RequestSearchParamsDTO, params: RequestParams = {}) =>
    this.request<RequestSearchResultDTO, ErrorResponse>({
      path: `/api/requests`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name UnpublishRequest
   * @summary Withdraw a published request.
   * @request POST:/api/requests/{id}/unpublish
   * @secure
   */
  unpublishRequest = (
    id: number,
    query: {
      cancellationReason: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/unpublish`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name UpdateAdditionalInformation
   * @summary Update the additional information of a request (PUBLISHED, TO_BE_CONFIRMED, IN_NEGOTIATION)
   * @request POST:/api/requests/{id}/additional-information
   * @secure
   */
  updateAdditionalInformation = (
    id: number,
    data: UpdateAdditionalInformationDTO,
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/additional-information`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name UpdateAndPublishRequest
   * @summary Update an publish an existing request by ID
   * @request PUT:/api/requests/{id}/update-and-publish
   * @secure
   */
  updateAndPublishRequest = (
    id: number,
    data: RequestDTO,
    params: RequestParams = {},
  ) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}/update-and-publish`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name UpdateRequest
   * @summary Update an existing request by ID
   * @request PUT:/api/requests/{id}
   * @secure
   */
  updateRequest = (id: number, data: RequestDTO, params: RequestParams = {}) =>
    this.request<RequestDTO, ErrorResponse | RequestDTO>({
      path: `/api/requests/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-api
   * @name ValidateRequestDates
   * @summary Validate request dates
   * @request POST:/api/requests/validate-dates
   * @secure
   */
  validateRequestDates = (
    data: RequestValidationParamsDTO,
    params: RequestParams = {},
  ) =>
    this.request<ErrorResponse, ErrorResponse>({
      path: `/api/requests/validate-dates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
